import { Rule } from 'antd/lib/form';
import FormInput from 'components/Input/FormInput';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

interface IProps {
	onChange: (value: string) => void;
	settingsId: string;
}

export const StoreField: React.FC<IProps> = React.memo(({ onChange, settingsId }) => {
	const { t } = useTranslation('error');
	const validationRules = useMemo<Rule[]>(() => [{ required: true, message: t('enterStore') }], [t]);

	return (
		<FormInput
			testId="StoreField"
			name={`store-${settingsId}`}
			label="storeLabel"
			onChange={onChange}
			validationRules={validationRules}
		/>
	);
});
